import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Input from 'components/common/Input';

const PersonForm = ({ data }) => {
 const {
  reset,
  watch,
  register,
  setValue,
  getValues,
  formState: { errors }
 } = useForm();

 useEffect(() => {
  const form = getValues();
  reset({ ...form, ...data });
 }, [data]);

 return (
  <>
   <Row className="mb-3">
    <Input
     type="select"
     label="Tipo de documento"
     name="docType"
     placeholder="Documento"
     errors={errors}
     formGroupProps={{ as: Col, lg: 7 }}
     formControlProps={{ ...register('docType') }}
     options={[
      { label: 'Cedula de Ciudadanía', value: 'CC' },
      { label: 'Cedula Extranjera', value: 'CE' },
      { label: 'Permiso Especial', value: 'PEP' },
      { label: 'Cedula C. Venezolana', value: 'CCVE' }
     ]}
    />
    <Input
     type="text"
     label="Documento"
     name="docNumber"
     errors={errors}
     formGroupProps={{ as: Col, lg: 5 }}
     formControlProps={{ ...register('docNumber') }}
    />
   </Row>

   <Input
    type="text"
    label="Expedido en"
    name="docFrom"
    errors={errors}
    formGroupProps={{ className: 'w-100 mb-3' }}
    formControlProps={{ ...register('docFrom') }}
   />

   <Row className="mb-3">
    <Input
     type="text"
     label="Nombres"
     name="firstName"
     errors={errors}
     formGroupProps={{ as: Col, lg: 6 }}
     formControlProps={{ ...register('firstName', { required: true }) }}
    />
    <Input
     type="text"
     label="Apellidos"
     name="lastName"
     errors={errors}
     formGroupProps={{ as: Col, lg: 6 }}
     formControlProps={{ ...register('lastName', { required: true }) }}
    />
   </Row>

   <Row className="mb-3">
    <Input
     label="Movil"
     type="tel"
     name="phone"
     errors={errors}
     placeholder="Numero cel"
     formGroupProps={{ as: Col, sm: 6 }}
     formControlProps={{
      type: 'tel',
      autoComplete: 'tel',
      value: watch('phone'),
      onChange: e => setValue('phone', e)
      //countryCallingCodeEditable={true}
      //defaultCountry: 'CO'
     }}
    />
    <Form.Control
     type="hidden"
     {...register('phone', {
      required: 'Movil requerido',
      minLength: { value: 10, message: 'Movil invalido' },
      pattern: { value: /[+0-9]/i, message: 'Solo numeros' }
     })}
    />

    <Input
     type="text"
     label="Email"
     name="email"
     errors={errors}
     formGroupProps={{ as: Col, lg: 6 }}
     formControlProps={{
      className: 'input-spin-none',
      ...register('email', {
       required: 'Debe especificar un email',
       pattern: {
        value: /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/i,
        message: 'Email invalido'
       }
      })
     }}
    />
   </Row>

   <Row className="mb-3">
    <Input
     type="text"
     label="Ciudad"
     name="city"
     errors={errors}
     formGroupProps={{ as: Col, lg: 4 }}
     formControlProps={{ ...register('city', { required: true }) }}
    />
    <Input
     type="text"
     label="Direccion"
     name="address"
     errors={errors}
     formGroupProps={{ as: Col, lg: 8 }}
     formControlProps={{ ...register('address', { required: true }) }}
    />
   </Row>
  </>
 );
};

PersonForm.propTypes = { data: PropTypes.object };

PersonForm.defaultProps = { data: {} };

export default PersonForm;
